// Récupère la valeur d'un cookie par son nom
export const getCookie = (name) => {
    // On ajoute un point-virgule au début pour éviter les erreurs de découpage
    const value = `; ${document.cookie}`;
    // On découpe la chaîne sur le nom du cookie suivi de "="
    const parts = value.split(`; ${name}=`);
    // Si on trouve bien ce cookie, on retourne sa valeur (jusqu'au prochain ';')
    if (parts.length === 2) return parts.pop().split(';').shift();
    // Sinon on retourne null
    return null;
};

// Définit un cookie avec un nom, une valeur et une durée d'expiration en jours (par défaut 365 jours)
export const setCookie = (name, value, days = 365) => {
    // Calcule la date d'expiration au format UTC
    const expires = new Date(Date.now() + days * 86400000).toUTCString();
    // Définit le cookie avec encodage de la valeur, expiration et path accessible partout
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
};

// URL de base de l'API (issue des variables d'environnement)
const API_URL = process.env.REACT_APP_API_URL;

/**
 * Envoie un log d'action à l'API
 * @param {Object} params - objet contenant les infos de log
 * @param {string} params.action - type d'action (ex: "disconnection")
 * @param {string|number} params.dossierId - ID du dossier concerné
 * @param {string} [params.email] - email de l'utilisateur (récupéré dans un cookie si absent)
 * @param {string} [params.fichier] - fichier concerné par l'action (optionnel)
 * @param {string} [params.path] - chemin concerné par l'action (optionnel)
 */
export const logAction = async ({ action, dossierId, email, fichier, path }) => {
    // Si email non défini, on tente de le récupérer depuis le cookie "authEmail"
    if (email === undefined) {
        email = getCookie('authEmail');
    }
    try {
        // Envoi de la requête POST avec les données au serveur
        await fetch(`${API_URL}/controllers/logs.php`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include', // pour envoyer les cookies avec la requête
            body: JSON.stringify({
                id_dossier: dossierId,
                action,
                email,
                authorization: getCookie('userPartage'),
                fichier,
                path,
            }),
        });
    } catch (err) {
        // En cas d'erreur lors de l'envoi, on log l'erreur dans la console
        console.error("Erreur lors de l'envoi du log :", err);
    }
};
